



















import Component from "vue-class-component";
import Vue from "vue";
import { FormFields, FormValues } from "@/types";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import { Prop } from "vue-property-decorator";
import PageTitle from "@/components/PageTitle.vue";
import { $t } from "@/lib/helpers/i18nHelper";

@Component({
  name: "FormAddEditBlock",
  components: { BlockBaseForm, BlockBase, PageTitle },
})
export default class FormAddEditBlock extends Vue {
  @Prop({ type: String, default: $t("Create Category") })
  public readonly nameBlock!: string;

  @Prop({ type: String })
  public currentValue!: string | undefined;

  @Prop({ type: Boolean })
  public allowDelete!: boolean | undefined;

  get fields(): FormFields {
    return [
      {
        name: "title",
        title: "Category Name",
        placeholder: $t("E.g. Cats"),
        value: this.currentValue,
      },
    ];
  }

  get isSave() {
    return this.currentValue !== undefined;
  }

  public save(currentValues: FormValues, BlockBaseFormInstance: any) {
    this.$emit("save", currentValues, BlockBaseFormInstance);
  }
}
